import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const FixedRatioImage = ({ src, alt, size }) => {
    const styles = {
        backgroundImage: 'url(' + src + ')',
        backgroundSize: size,
    };

    const classes = classNames({
        'fixed-ratio-image': true,
        'fixed-ratio-image--square': true,
    });

    return (
        <div className={classes} data-loaded>
            <div className="fixed-ratio-image__inner" style={styles}>
                <img className="fixed-ratio-image__inner__image" src={src} alt={alt} />
            </div>
        </div>
    );
};
FixedRatioImage.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    size: PropTypes.string,
};
FixedRatioImage.defaultProps = {
    alt: '',
};

export default FixedRatioImage;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/fixed-ratio-image.jsx